import { ModelBase } from 'store/model-base';

export interface AddRemoveAddonsOrder {
    lineIdKey: string;
    orderId: string;
}

export class AddRemoveAddons extends ModelBase {
    public static storeName: string = 'addRemoveAddons';

    public requestId?: string;
    public orders?: AddRemoveAddonsOrder[];
    public code?: string;
    public message?: string;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: AddRemoveAddons = super.create<AddRemoveAddons>(initData);
        
        return super.create<T>(toReturn);
    }
}
